import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./EnergyPackages.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getEnergyPackages,
  getPurchaseLink,
  checkPaymentStatus,
  getUserProfile,
  updateProfile,
} from "../../../lib/store/actions";
import LoaderCstm from "../../Loader";
import { createPortal } from "react-dom";
import current from "../../../assets/images/current.png";
import { showToast } from "../../../helper/common";
import { useTonConnectUI } from "@tonconnect/ui-react";
import VerifyingPaymentLoader from "../../Loader/verifyPayment";
import tokenIcn from "../../../assets/images/usdt-ton.png";
import {
  getUsdtWalletAddress,
  getNetworkName,
  usePreventTonModalClose,
} from "../../../helper/common";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";
const GAS_FEE = "50000000";

const EnergyPackages = ({ showPackages, setShowPackages }) => {
  // const { t } = useTranslation();
  const t = useLanguage();

  usePreventTonModalClose();
  const dispatch = useDispatch();
  const { loadingEnergyPackages, energyPackageList, settingsData, userData } =
    useSelector(({ Settings, Auth, Energy }) => ({
      userData: Auth.user,
      loadingEnergyPackages: Energy.loadingEnergyPackages,
      energyPackageList: Energy.energyPackageList,
      totalEnergyPackages: Energy.totalEnergyPackages,
      settingsData: Settings.settings,
    }));
  const [loading, setLoading] = useState(false);
  const [tonConnectUI] = useTonConnectUI();
  const [isPaying, setIsPaying] = useState(false);
  const [selected, setSelected] = useState(null);
  const [verify, setVerify] = useState(false);

  const handleShowPackage = () => {
    setShowPackages(!showPackages);
  };

  const handlePurchase = async (packageId, energy) => {
    if (isPaying) {
      showToast("Please wait for previous transaction completion", "error");
    }
    if (verify) {
      showToast("Please wait for previous transaction completion", "error");
    }
    if (
      settingsData?.energy?.maxEnergyBalance <
      userData.energyBalance + energy
    ) {
      showToast("Purchase not allowed—exceeds max energy limit.", "info");
      return;
    }
    if (!tonConnectUI?.connected) {
      let response = await tonConnectUI.openModal();
      // console.info("response for open modal", response);
      if (tonConnectUI?.account) {
        const networkName = getNetworkName(tonConnectUI?.account?.chain);
        const targetNetwork = settingsData?.payment?.tonNetwork;
        if (networkName !== targetNetwork) {
          showToast(
            `Please switch your wallet network manually to ${targetNetwork} and reconnect!`,
            "error",
          );
          return;
        }
      }
      // console.info("Address after open modal", tonConnectUI?.account?.address);
    }
    if (tonConnectUI && !tonConnectUI?.connected) {
      let response = await tonConnectUI.openModal();
      // console.info("response for open modal", response);

      // console.info("Address after open modal", tonConnectUI?.account?.address);
      if (tonConnectUI?.account?.address) {
        setLoading(true);
        dispatch(
          updateProfile({
            data: {
              _id: userData?._id,
              walletAddress: tonConnectUI?.account?.address,
            },
            callBack: (err, data) => {
              if (err) {
                setLoading(false);
                showToast("Network Error! Please try later.", "error");
                return;
              }
              dispatch(
                getPurchaseLink({
                  data: {
                    quantity: 1,
                    energyPackageId: packageId,
                  },
                  callBack: async (err, res) => {
                    if (err) {
                      setLoading(false);
                      showToast("Network Error! Please try later.", "error");
                      return;
                    }
                    setLoading(!loading);
                    setIsPaying(true);
                    const { purchaseID, payload } = res.data;
                    if (tonConnectUI?.connected) {
                      const userTonAddress = tonConnectUI?.account?.address;
                      const userUSDTAddress = await getUsdtWalletAddress(
                        userTonAddress,
                        settingsData,
                      );
                      if (userUSDTAddress) {
                        try {
                          await tonConnectUI.sendTransaction({
                            validUntil: Math.floor(Date.now() / 1000) + 300,
                            // network: settingsData?.payment?.tonNetwork,
                            messages: [
                              {
                                address: userUSDTAddress || userTonAddress,
                                amount: GAS_FEE,
                                payload: payload,
                              },
                            ],
                          });
                          setLoading(false);
                          setVerify(true);
                          await verifyPayment(purchaseID);
                        } catch (error) {
                          setLoading(false);
                          setIsPaying(false);
                          showToast("Transaction was cancelled!", "error");
                        }
                      } else {
                        showToast("USDT Wallet not found!", "error");
                        setLoading(!loading);
                        setIsPaying(false);
                        setVerify(false);
                      }
                    }
                  },
                }),
              );
            },
          }),
        );
      }
    } else if (tonConnectUI?.connected) {
      if (tonConnectUI?.account) {
        const networkName = getNetworkName(tonConnectUI?.account?.chain);
        const targetNetwork = settingsData?.payment?.tonNetwork;
        if (networkName !== targetNetwork) {
          showToast(
            `Please switch your wallet network manually to ${targetNetwork}`,
            "error",
          );
          return;
        }
      }
      // console.info("Address for connected ", tonConnectUI?.account?.address);
      setLoading(true);
      dispatch(
        getPurchaseLink({
          data: {
            quantity: 1,
            energyPackageId: packageId,
          },
          callBack: async (err, res) => {
            if (err) {
              setLoading(false);
              showToast("Network Error! Please try later.", "error");
              return;
            }
            setLoading(!loading);
            setIsPaying(true);
            const { purchaseID, payload } = res.data;
            if (tonConnectUI?.connected) {
              const userTonAddress = tonConnectUI?.account?.address;
              const userUSDTAddress = await getUsdtWalletAddress(
                userTonAddress,
                settingsData,
              );
              if (userUSDTAddress) {
                try {
                  await tonConnectUI.sendTransaction({
                    validUntil: Math.floor(Date.now() / 1000) + 300,
                    // network: settingsData?.payment?.tonNetwork,
                    messages: [
                      {
                        address: userUSDTAddress || userTonAddress,
                        amount: GAS_FEE,
                        payload: payload,
                      },
                    ],
                  });
                  setLoading(false);
                  setVerify(true);
                  await verifyPayment(purchaseID);
                } catch (error) {
                  setLoading(false);
                  setIsPaying(false);
                  showToast("Transaction was cancelled!", "error");
                }
              } else {
                showToast("USDT Wallet not found!", "error");
                setLoading(!loading);
                setIsPaying(false);
                setVerify(false);
              }
            }
          },
        }),
      );
    } else {
      showToast("Please connect telegram wallet!", "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(
      getEnergyPackages({
        data: {
          page: 1,
          limit: 20,
          order: -1,
          orderBy: "date_created_utc",
        },
      }),
    );
  }, [dispatch]);

  const verifyPayment = async (purchaseID) => {
    try {
      const checkPayment = async (attempts = 0) => {
        if (attempts > 20) {
          throw new Error("Timeout waiting for payment");
        }
        if (!purchaseID) {
          throw new Error("No purchase ID provided");
        }
        try {
          const res = await dispatch(
            checkPaymentStatus({ data: { purchaseID } }),
          ).unwrap();
          if (res?.status === "success") {
            showToast("Package Purchased Successfully!", "success");
            setVerify(false);
            handleShowPackage();
            dispatch(
              getUserProfile({
                data: {
                  _id: userData?._id,
                },
                callBack: (err, res) => {
                  if (err) return;
                },
              }),
            );
            return;
          } else {
            await new Promise((resolve) => setTimeout(resolve, 5000));
            return await checkPayment(attempts + 1);
          }
        } catch (err) {
          console.error("Error checking payment:", err);
          setVerify(false);
          setLoading(false);
          setIsPaying(false);
          showToast("Package Payment timeout!", "error");
          handleShowPackage();
        }
      };
      await checkPayment();
      handleShowPackage();
    } catch (error) {
      console.error("Verification error:", error);
      showToast("Package Payment timeout!", "error");
      handleShowPackage();
    } finally {
      setLoading(false);
      setIsPaying(false);
      setVerify(false);
    }
  };

  return (
    <>
      <Modal
        show={showPackages}
        onHide={handleShowPackage}
        backdrop="true"
        centered
        className={`${styles.EnergyPackages} bottomPop allow-scroll`}
        keyboard={false}
        scrollable="true"
      >
        <div className="modalWrpper">
          {(loading || loadingEnergyPackages) &&
            createPortal(<LoaderCstm />, document.body)}
          {verify && <VerifyingPaymentLoader />}
          <Modal.Body>
            <Button
              onClick={handleShowPackage}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>

            <div className="top pb-3 text-center">
              <h5
                className="m-0 d-inline-block pb-1 px-3"
                style={{ color: "#54B3F5" }}
              >
                {t("energypackage_pop.refill_your_energy")}
              </h5>
            </div>

            <div
              className="row overflow-auto py-3 mx-auto"
              style={{ maxWidth: 314 }}
            >
              {energyPackageList?.map((pkg) => (
                <div
                  key={pkg._id}
                  className={`${styles.card}  card rounded-4 mb-2 ps-3 ${
                    selected?._id?.toString() === pkg?._id?.toString()
                      ? styles.selected
                      : ""
                  }`}
                  style={{ backgroundColor: "#13131B", paddingRight: 35 }}
                  onClick={() => {
                    setSelected(pkg);
                  }}
                  onSelect={() => {
                    setSelected(pkg);
                  }}
                >
                  <div className="card-body row text-white py-2 align-items-center px-0">
                    {pkg?.isHotOffer ? (
                      <div className="col-5 flex-shrink-0 position-relative">
                        <div
                          className={`${styles.hotOffer} position-absolute d-flex align-items-center px-2`}
                          style={{ background: "#242AFC", top: -18, left: 15 }}
                        >
                          <span className="icn me-1">{clockIcn}</span>
                          <p className="m-0 text-white">
                            {t("energypackage_pop.hot_offer")}
                          </p>
                        </div>
                        <img
                          src={pkg?.logo}
                          alt=""
                          className="img-fluid object-fit-contain align-items-center"
                          style={{
                            height: "100%",
                            maxHeight: 80,
                            marginTop: 12,
                            marginLeft: 15,
                          }}
                        />
                      </div>
                    ) : (
                      <div className="col-5">
                        <img
                          className="img-fluid object-fit-contain align-items-center"
                          style={{
                            height: "100%",
                            maxHeight: 80,
                            marginTop: 12,
                            marginLeft: 15,
                          }}
                          src={pkg?.logo}
                          alt="Energy Icon"
                        />
                      </div>
                    )}

                    <div className="d-flex flex-column col-7">
                      <h2
                        className="card-title fw-bold"
                        style={{ fontSize: 16 }}
                      >
                        {t("energypackage_pop.energy")}
                      </h2>

                      <div className="d-flex justify-content-between align-items-center w-100 gap-10">
                        <div className="d-flex align-items-center badge">
                          <img
                            className="img-fluid"
                            src={current}
                            alt="Icon"
                            style={{
                              width: "16px",
                              height: "16px",
                              marginRight: "2px",
                            }}
                          />
                          <span
                            className="fw-bold"
                            style={{
                              fontSize: "16px",
                            }}
                          >
                            {pkg?.energy}{" "}
                            <span style={{ fontSize: 10 }}>X</span>{" "}
                          </span>
                        </div>
                        <span
                          className="badge px-3 py-2"
                          style={{
                            fontSize: "10px",
                            background: "#1B223A",
                          }}
                        >
                          {pkg?.name}
                        </span>
                      </div>

                      <Button
                        variant="primary"
                        className={`${styles.submitBtn} w-100 d-flex align-items-center justify-content-center gap-10 fw-bold mt-3`}
                        disabled={
                          settingsData?.energy?.maxEnergyBalance <
                          userData?.energyBalance + pkg?.energy
                        }
                      >
                        {pkg?.discountPercent > 0 && (
                          <del
                            className=""
                            style={{
                              color: "#9194FE",
                              fontWeight: 400,
                              fontSize: 10,
                            }}
                          >
                            <img
                              src={tokenIcn}
                              style={{ height: 20, width: 20 }}
                              alt=""
                              className="img-fluid flex-shrink-0 object-fit-contain"
                            />
                            {pkg?.price}
                          </del>
                        )}
                        <img
                          src={tokenIcn}
                          style={{ height: 16, width: 16 }}
                          alt=""
                          className="img-fluid flex-shrink-0 object-fit-contain"
                        />{" "}
                        {pkg?.discountedPrice}
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
              <Button
                variant="primary"
                className={`${styles.submitBtn} w-100 d-flex align-items-center justify-content-center fw-bold mt-3 mb-3`}
                onClick={() => handlePurchase(selected?._id, selected?.energy)}
                disabled={!selected}
              >
                {selected
                  ? `${t("energypackage_pop.buy_for")} $${
                      selected.discountedPrice
                    }`
                  : t("energypackage_pop.buy")}
              </Button>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default EnergyPackages;

const clockIcn = (
  <svg
    width="9"
    height="9"
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.22932 3.80942C6.22932 5.20066 5.10214 6.32978 3.71329 6.32978C2.32445 6.32978 1.19727 5.20066 1.19727 3.80942C1.19727 2.41818 2.32445 1.28906 3.71329 1.28906C5.10214 1.28906 6.22932 2.41818 6.22932 3.80942Z"
      stroke="white"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.64763 4.61085L3.86766 4.14458C3.7318 4.06393 3.62109 3.86986 3.62109 3.71108V2.67773"
      stroke="white"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
